import useUser from './useUserHook';
import { useEffect } from 'react';
import PropTypes from 'prop-types';

/**
 * @param {{featureList?: string[], redirectOnFailure?: boolean}} props
 * @returns {boolean[]}
 */
const useFeaturePermissionsHook = (props) => {
    const userData = useUser();
    const matchedPermissions = [];

    if (Array.isArray(props?.featureList)) {
        for (const feature of props.featureList) {
            if (userData?.features?.[feature]) {
                matchedPermissions.push(true);
            } else {
                matchedPermissions.push(false);
            }
        }
    }

    useEffect(() => {
        if (props?.redirectOnFailure && (matchedPermissions.includes(false) || matchedPermissions.length === 0)) {
            window.location.assign(`${process.env['REACT_APP_INTELY_UI_EXTERNAL_HOST']}/my-profile`);
        }
    }, []);

    return matchedPermissions;
};

useFeaturePermissionsHook.propTypes = {
    featureList: PropTypes.arrayOf(PropTypes.string),
    redirectOnFailure: PropTypes.bool,
};

export default useFeaturePermissionsHook;
